import { Select } from '@mui/material';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
 background-color:white !important;
 width:${props => props.width ? props.width + ' !important' : '100%'};
 font-size: 1rem !important;
 padding: 2px;
 
  &>div,&>div:hover,&>div:focus,&:disabled{
    background-color:white !important;
    color:black !important;
  }
  `